import React from 'react';
import { Mail, Phone, MapPin, MessageSquare } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen text-white pt-20 md:pt-32">
      {/* Hero Section - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
            Parlons de Votre Projet
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#017D7E] to-[#00A99D]">
              Contactez-nous
            </span>
          </h1>
          <p className="text-base md:text-xl text-white/70">
            Notre équipe d'experts est à votre disposition pour discuter de vos besoins et vous accompagner dans votre transformation digitale.
          </p>
        </div>
      </div>

      {/* Contact Methods - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 max-w-5xl mx-auto">
          <div className="bg-white/5 rounded-xl p-6 md:p-8 border border-white/10 text-center">
            <div className="w-12 h-12 rounded-lg bg-[#017D7E]/10 flex items-center justify-center mx-auto mb-4">
              <Mail className="w-6 h-6 text-[#017D7E]" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2">Email</h3>
            <p className="text-white/70 text-sm md:text-base">contact@kg-technologies.fr</p>
          </div>

          <div className="bg-white/5 rounded-xl p-6 md:p-8 border border-white/10 text-center">
            <div className="w-12 h-12 rounded-lg bg-[#017D7E]/10 flex items-center justify-center mx-auto mb-4">
              <Phone className="w-6 h-6 text-[#017D7E]" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2">Téléphone</h3>
            <p className="text-white/70 text-sm md:text-base">+212 (0) 522 78 45 89</p>
          </div>

          <div className="bg-white/5 rounded-xl p-6 md:p-8 border border-white/10 text-center">
            <div className="w-12 h-12 rounded-lg bg-[#017D7E]/10 flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-6 h-6 text-[#017D7E]" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold mb-2">Adresse</h3>
            <p className="text-white/70 text-sm md:text-base">332, BD BRAHIM ROUDANI, ETAGE 5, BUREAU 21, RESIDENCE RAYHANE, Quartier Maarif, 20310 CASABLANCA, MAROC</p>
          </div>
        </div>
      </div>

      {/* Contact Form - Adapté pour mobile */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-2xl mx-auto bg-white/5 rounded-xl p-4 md:p-8 border border-white/10">
          <div className="flex gap-3 md:gap-4 items-center mb-6 md:mb-8">
            <div className="p-2 rounded-lg bg-[#017D7E]/10">
              <MessageSquare className="w-5 h-5 md:w-6 md:h-6 text-[#017D7E]" />
            </div>
            <h2 className="text-xl md:text-2xl font-semibold">Envoyez-nous un message</h2>
          </div>

          <form className="space-y-4 md:space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              <div>
                <label className="block text-sm font-medium mb-1.5 md:mb-2">Nom</label>
                <input
                  type="text"
                  className="w-full px-3 md:px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm md:text-base"
                  placeholder="Votre nom"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1.5 md:mb-2">Email</label>
                <input
                  type="email"
                  className="w-full px-3 md:px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm md:text-base"
                  placeholder="votre@email.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1.5 md:mb-2">Sujet</label>
              <input
                type="text"
                className="w-full px-3 md:px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white text-sm md:text-base"
                placeholder="Sujet de votre message"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1.5 md:mb-2">Message</label>
              <textarea
                className="w-full px-3 md:px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white h-24 md:h-32 text-sm md:text-base"
                placeholder="Votre message..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full py-2.5 md:py-3 px-4 md:px-6 rounded-lg bg-gradient-to-r from-green-500 to-[#017D7E] text-white font-medium hover:from-green-600 hover:to-emerald-600 transition-all text-sm md:text-base"
            >
              Envoyer le message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;